import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Komponent przewijający stronę do góry przy nawigacji.
 * Ignoruje akcję "POP" (wstecz/dalej w przeglądarce), aby zachować natywną pozycję scrolla.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    // Przewijaj do góry tylko jeśli to nowa strona (PUSH/REPLACE)
    // Nie przewijaj przy powrocie (POP)
    if (navType !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [pathname, navType]);

  return null;
}
